import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { getItem } from "../../api/generics";
import { CreditNote, formatCreditNoteNumber } from "../../models/credit-note";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import CreditNoteDetailView from "./CreditNoteDetailView";

interface CreditNoteDetailModalProps {
  show: boolean;
  creditNote?: CreditNote;
  onCancel: () => void;
}

const CreditNoteDetailModal: React.FC<CreditNoteDetailModalProps> = ({
  show,
  creditNote,
  onCancel,
}) => {
  const [fullCreditNote, setFullCreditNote] = useState<CreditNote | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !creditNote?.id) {
      setFullCreditNote(undefined);
      return;
    }
    const fetch = async () => {
      setLoading(true);
      const result = await getItem<CreditNote>(
        `/credit_notes/${creditNote.id}/`,
      );
      if (result.status === SUCCESS && result.data) {
        setFullCreditNote(result.data);
      } else {
        errorAlert("No se pudo cargar el detalle de la nota de crédito.");
        onCancel();
      }
      setLoading(false);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, creditNote?.id]);

  const title =
    creditNote?.creditNoteNumber
      ? `Nota de Crédito ${formatCreditNoteNumber(creditNote)}`
      : "Detalle de Nota de Crédito";

  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          fullCreditNote && <CreditNoteDetailView creditNote={fullCreditNote} />
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cerrar
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CreditNoteDetailModal;
